<template>
  <v-dialog v-model="show" max-width="300px">
    <v-card>
      <v-card-text class="text-center pa-4">
        {{ message }}
      </v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn color="#ED7D31" dark @click="$emit('close')">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
    message: String,
  },
};
</script>
